import * as React from "react";
import { forwardRef } from "react";
const SvgForward = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-forward-icon lucide-forward", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m15 17 5-5-5-5" }), /* @__PURE__ */ React.createElement("path", { d: "M4 18v-2a4 4 0 0 1 4-4h12" }));
const ForwardRef = forwardRef(SvgForward);
export default ForwardRef;
